const formatDateToBR = (isoDate) => {
    if (!isoDate) return '';

    const date = new Date(isoDate);

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(date)) return 'Data inválida';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export default formatDateToBR;
